const STORAGE_KEY = "twin_page_view";

type PageViewMap = Record<string, number>;

function readAll(): PageViewMap {
  const raw = localStorage.getItem(STORAGE_KEY);
  if (!raw) return {};
  try {
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === "object" ? (parsed as PageViewMap) : {};
  } catch {
    return {};
  }
}

function getViewCount(route: string): number {
  return readAll()[route] ?? 0;
}

function incrementViewCount(route: string): number {
  const map = readAll();
  const next = (map[route] ?? 0) + 1;
  map[route] = next;
  localStorage.setItem(STORAGE_KEY, JSON.stringify(map));
  return next;
}

export const pageViewStorage = {
  getViewCount,
  incrementViewCount,
};
